import { put, call } from "@redux-saga/core/effects";
import axios from "axios";
import { googleLoginFailure, googleLoginSuccess } from "../actionCreators";

import { IErrorType } from "./../../types/errors.d";
import { GoogleLoginRequestActionType } from "../types";
import { AuthService, GoogleLoginResponse } from "../../../services/auth";

export function* googleSignInRequest({ payload: { access_token, token_type } }: GoogleLoginRequestActionType) {
    try {
        const { data: googleData }: GoogleLoginResponse = yield call(
            axios.get,
            "https://openidconnect.googleapis.com/v1/userinfo",
            {
                headers: {
                    Authorization: `${token_type} ${access_token}`,
                },
                params: {
                    scope: "profile https://www.googleapis.com/auth/userinfo.email",
                },
            },
        );

        const { data } = yield AuthService.initGoogleLoggedUser({
            email: googleData.email,
            family_name: googleData.family_name,
            given_name: googleData.given_name,
            provider: "google",
            socialId: googleData.sub,
            picture: googleData.picture,
        });

        if (data.success) {
            yield put(googleLoginSuccess({ access_token: data.data.token, refresh_token: data.data.refresh_token }));
        }
    } catch (error) {
        let errorType = IErrorType.NATIVE;
        let errorData = error;
        if (axios.isAxiosError(error)) {
            errorType = IErrorType.AXIOS;
            errorData = error.response ? error.response.data : null;
        }

        yield put(googleLoginFailure({ errorType, data: errorData }));
    }
}
